<template>
  <div id="Add_update" class="xv_modal">
    <div class="modal_title">
      <div>
        <span>Update</span>
      </div>
      <div>
        <button class="modal_close" @click="close_add_update()">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    <div class="modal_content">
      <div class="type">
        <b-form-group label="Type">
          <b-form-radio v-model="type" name="type" value="type_1">Diagnostics</b-form-radio>
          <b-form-radio v-model="type" name="type" value="type_2">International arrival</b-form-radio>
        </b-form-group>
      </div>
      <div class="type_layout trace">
        <div class="section diagnostics" v-if="type == 'type_1'">
          <label class="sec_title">Diagnostics</label>
          <div class="content">
            <div class="data_row">
              <div class="data_col">
                <div class="title">
                  <span>Date</span>
                </div>
                <div class="value">
                  <div class="xv_datepicker">
                    <span class="mdi mdi-calendar-month"></span>
                    <vc-date-picker
                      mode="single"
                      v-model="selectedDate"
                      :popover="{ visibility: 'click' }"
                      :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select date',
                    readonly: true
                  }"
                      :masks="{ input: 'DD/MM/YY' }"
                    />
                  </div>
                </div>
              </div>

              <div class="data_col">
                <div class="title">
                  <span>Sample Id</span>
                </div>
                <div class="value">
                  <input type="text" />
                </div>
              </div>

              <div class="data_col">
                <div class="title">
                  <span>Status</span>
                </div>
                <div class="value">
                  <input type="text" />
                </div>
              </div>
            </div>
            <div class="second_row">
              <div class="data_col">
                <div class="title">
                  <span>Comments</span>
                </div>
                <div class="value">
                  <textarea></textarea>
                </div>
              </div>

              <div class="data_col multi">
                <div class="line_1">
                  <div class="left">
                    <div class="title">
                      <span>Assigned to</span>
                    </div>
                    <div class="value">
                      <input type="text" />
                    </div>
                  </div>
                  <div class="right">
                    <div class="title">
                      <span>Date</span>
                    </div>
                    <div class="value">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="single"
                          v-model="selectedDate"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select date',
                    readonly: true
                  }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="health_status">
            <div class="data">
              <div class="left">
                <label>Temperature</label>
                <div>
                  <input type="text" />
                </div>
              </div>
              <div class="right">
                <label>Symptoms</label>
                <div class="check_wrap">
                  <b-form-checkbox id="checkbox-7" name="checkbox-7" value="fever">Fever</b-form-checkbox>
                  <b-form-checkbox id="checkbox-8" name="checkbox-8" value="Sore throat">Sore throat</b-form-checkbox>
                  <b-form-checkbox id="checkbox-9" name="checkbox-9" value="accepted">Headache</b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section international_arrival" v-if="type == 'type_2'">
          <label class="sec_title">International arrival</label>
          <div class="content">
            <div class="data_row">
              <div class="data_col">
                <div class="title">
                  <span>Date</span>
                </div>
                <div class="value">
                  <div class="xv_datepicker">
                    <span class="mdi mdi-calendar-month"></span>
                    <vc-date-picker
                      mode="single"
                      v-model="selectedDate"
                      :popover="{ visibility: 'click' }"
                      :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select date',
                    readonly: true
                  }"
                      :masks="{ input: 'DD/MM/YY' }"
                    />
                  </div>
                </div>
              </div>

              <div class="data_col">
                <div class="title">
                  <span>Fligt no</span>
                </div>
                <div class="value">
                  <input type="text" />
                </div>
              </div>

              <div class="data_col">
                <div class="title">
                  <span>Arrived from</span>
                </div>
                <div class="value">
                  <input type="text" />
                </div>
              </div>

              <div class="data_col">
                <div class="title">
                  <span>Travelling to</span>
                </div>
                <div class="value">
                  <input type="text" />
                </div>
              </div>
            </div>
            <div class="second_row">
              <div class="data_col">
                <div class="title">
                  <span>Comments</span>
                </div>
                <div class="value">
                  <textarea></textarea>
                </div>
              </div>

              <div class="data_col multi">
                <div class="line_1">
                  <div class="left">
                    <div class="title">
                      <span>Assigned to</span>
                    </div>
                    <div class="value">
                      <input type="text" />
                    </div>
                  </div>
                  <div class="right">
                    <div class="title">
                      <span>Date</span>
                    </div>
                    <div class="value">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="single"
                          v-model="selectedDate"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select date',
                    readonly: true
                  }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="line_2">
                  <div class="left">
                    <div class="title">
                      <span>Updated by</span>
                    </div>
                    <div class="value">
                      <input type="text" />
                    </div>
                  </div>
                  <div class="right">
                    <div class="title">
                      <span>Date</span>
                    </div>
                    <div class="value">
                      <div class="xv_datepicker">
                        <span class="mdi mdi-calendar-month"></span>
                        <vc-date-picker
                          mode="single"
                          v-model="selectedDate"
                          :popover="{ visibility: 'click' }"
                          :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select date',
                    readonly: true
                  }"
                          :masks="{ input: 'DD/MM/YY' }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="health_status">
            <div class="data">
              <div class="left">
                <label>Temperature</label>
                <div>
                  <input type="text" />
                </div>
              </div>
              <div class="right">
                <label>Symptoms</label>
                <div class="check_wrap">
                  <b-form-checkbox id="checkbox-10" name="checkbox-10" value="fever">Fever</b-form-checkbox>
                  <b-form-checkbox
                    id="checkbox-11"
                    name="checkbox-11"
                    value="Sore throat"
                  >Sore throat</b-form-checkbox>
                  <b-form-checkbox id="checkbox-12" name="checkbox-12" value="accepted">Headache</b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <button class="sec_btn m_r" @click="close_add_update()">Cancel</button>
      <button class="main_btn">Add</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Add_update",
  components: {},
  data() {
    return {
      type: "type_1"
    };
  },
  methods: {
    close_add_update: function() {
      this.$modal.hide("add_update");
    }
  }
};
</script>
